import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { Mediator } from '@spotahome/soyuz-mediator';

import { ListingCostsShape } from '../../constants/shapes';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import PaymentTimelineCard from './PaymentTimelineCard';
import PaymentTimeLineItem from './PaymentTimelineItem';

const noop = () => {};

const OnCheckIn = ({
  hasNoDeposit,
  isPricingCalculated,
  costs = {},
  currencyCode,
  isCollapsed = false,
  onSelectDates = noop
}) => {
  const totalValue = isPricingCalculated
    ? formatPrice(costs.total, currencyCode)
    : trans('book_now_modal.dates_input.label');

  const depositTag = hasNoDeposit
    ? {
        label: trans('search.filter.no-deposit.vp.title'),
        renderLeadingIcon: () => <DSIcon name="savings" size="m" />,
        isSpaced: true,
        underlined: true,
        size: 'big'
      }
    : {
        label: trans('homecard.label.deposit.protected'),
        renderLeadingIcon: () => <DSIcon name="lock_closed" size="m" />,
        isSpaced: true,
        underlined: true,
        size: 'big',
        onClick: () => {
          Mediator.publish(CHANNELS.OPEN_DEPOSIT_PROTECTION_MODAL);
        }
      };

  return (
    <PaymentTimelineCard
      title={trans('payment.timeline.section.on_check_in.title')}
      value={totalValue}
      tags={[depositTag]}
      collapsible
      isCollapsed={isCollapsed}
      onValueClick={!isPricingCalculated ? onSelectDates : null}
    >
      {costs?.costs?.map(cost => (
        <PaymentTimeLineItem
          key={cost.type}
          title={cost.name ?? trans(`payment.timeline.cost.label.${cost.type}`)}
          value={cost.value}
          currencyCode={currencyCode}
          included={cost.applyOn === APPLY_ON_INCLUDED}
          tooltipText={cost.description || null}
        />
      ))}
    </PaymentTimelineCard>
  );
};

OnCheckIn.propTypes = {
  hasNoDeposit: PropTypes.bool.isRequired,
  isPricingCalculated: PropTypes.bool.isRequired,
  costs: ListingCostsShape,
  currencyCode: PropTypes.string.isRequired,
  isCollapsed: PropTypes.bool,
  onSelectDates: PropTypes.func
};

export default OnCheckIn;
